@if (data$ | async; as data) {
  <app-card class="border" [class.error]="data.hasErrors">
    <div class="header">
      @if (data.hasErrors) {
        <h3 class="flex highlight">
          <app-icon name="ic_problem"/>
          {{ data.notificationList.length }}
          {{ 'dashboard.monitoring.hasError' | translate }}
        </h3>
      } @else {
        <app-text-with-icon name="ic_check" class="highlight">{{ 'dashboard.monitoring.noError' | translate }}</app-text-with-icon>
      }
    </div>
    @if (data.hasErrors) {
      <div class="body">
        <p>
          @if (data.notificationList.length > 0) {
            {{ data.notificationList[0].device?.name || (data.notificationList[0].rule | ruleName) }}
            @if (data.notificationList.length == 2) {
              {{ 'dashboard.monitoring.oneMoreError' | translate }}
            }
            @if (data.notificationList.length > 2) {
              {{ 'dashboard.monitoring.moreErrors' | translate:{count: data.notificationList.length - 1} }}
            }
          }
        </p>
      </div>
      <div class="footer">
        <a [routerLink]="['/', RouteConstants.routeNotifications]" [queryParams]="{level: NotificationLevel.ERROR}"
           class="button danger-button icon-button full-width">{{ 'dashboard.monitoring.showErrors' | translate }}
          <app-icon name="ic_chevron_right"></app-icon>
        </a>
      </div>
    } @else {
      <div class="footer">
        <a [routerLink]="['/', RouteConstants.routeNotifications]"
           class="button outlined-button icon-button full-width">{{ 'dashboard.monitoring.showNotifications' | translate }}
          <app-icon name="ic_chevron_right"></app-icon>
        </a>
      </div>
    }
  </app-card>
}
